import React, { useState } from "react";
import FacebookProvider, { Login } from "react-facebook-sdk";
import "../css/facebookLogin.css";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF } from '@fortawesome/free-brands-svg-icons';
import Button from '@mui/material/Button';

const Facebook = (props) => {
  const [login, setLogin] = useState(false);
  const language = useSelector((state) => state.languagesState.languages);

  const handleResponse = (response) => {
    window.localStorage.removeItem("swo");
    props.updatedData(response);
    props.updatedModaShow();
    setLogin(true);
  };
  const handleError = () => {};
  let fbContent;
  if (login) {
    fbContent = null;
  } else {
    fbContent = (
      <FacebookProvider appId={props.data && props.data.app_id && props.data.app_id.toString()}>
        <Login scope="email" onResponse={handleResponse} onError={handleError}>
          <Button variant="outlined" color="primary" className="facebook-login-btn">
            <FontAwesomeIcon icon={faFacebookF} className="mr-2" />
            {language?.welcomepage?.connect_with_facebook ?? "Connect With Facebook"}
          </Button>
        </Login>
      </FacebookProvider>
    );
  }
  return <div>{fbContent}</div>;
};

export default Facebook;
